import type Experiments from '@wix/wix-experiments';
import lodash from 'lodash';

import type { AvailableExperiments } from './../../ricos-types';
import { parseExperiments } from './../../wix-rich-content-common/lib/experiments';

export function experimentStrategy(
  wixExperiments?: Experiments | Record<string, string | boolean>
) {
  const features: {
    ricosFeatures: Record<string, never> | AvailableExperiments;
    wixRicosFeatures: Record<string, never> | AvailableExperiments;
  } = {
    ricosFeatures: {},
    wixRicosFeatures: {},
  };
  if (!wixExperiments) {
    return features;
  }

  const unboxed = lodash.isFunction(wixExperiments?.all) ? wixExperiments.all() : wixExperiments;

  const experiments = parseExperiments(unboxed as Record<string, string | boolean>);

  return Object.entries(experiments).reduce((featureList, [name, experiment]) => {
    if (experiment?.namespace === 'wixRicos') {
      featureList.wixRicosFeatures[name] = experiment;
    } else if (experiment?.namespace === 'ricos') {
      featureList.ricosFeatures[name] = experiment;
    }
    return featureList;
  }, features);
}
